import {
  LOADING_OPERATORS,
  LOADING_STATE,
  LOADING_STATE_INNER,
  SAVE_OPERATORS,
  SAVE_OPERATORS_LIST,
  SAVE_STATE,
  SAVING_CAMPAIGN,
  SAVING_CAMPAIGN_BOUGHT,
  SAVING_CAMPAIGN_DONE
} from "appRedux/constants";

const INIT_STATE = {
  operators: [],
  operatorsList: [],
  states: [],
  state_loading: false,
  isLoading: false,
  operator_loading: false,
  save_campaign: false,
  campaignBought: []
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case LOADING_OPERATORS: {
      return {
        ...state,
        operator_loading: true
      };
    }
    case SAVE_OPERATORS: {
      return {
        ...state,
        operator_loading: false,
        operators: action.payload
      };
    }
    case SAVE_OPERATORS_LIST: {
      return {
        ...state,
        operator_loading: false,
        operatorsList: action.payload
      };
    }
    case LOADING_STATE: {
      return {
        ...state,
        isLoading: true,
        state_loading: true
      };
    }
    case LOADING_STATE_INNER: {
      return {
        ...state,
        isLoading: true,
        state_loading: false
      };
    }
    case SAVE_STATE: {
      return {
        ...state,
        isLoading: false,
        state_loading: false,
        states: action.payload
      };
    }
    case SAVING_CAMPAIGN: {
      return {
        ...state,
        save_campaign: true
      };
    }
    case SAVING_CAMPAIGN_DONE: {
      return {
        ...state,
        save_campaign: false
      };
    }
    case SAVING_CAMPAIGN_BOUGHT: {
      return {
        ...state,
        campaignBought: action.payload
      };
    }
    default:
      return state;
  }
};
